<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Servicios</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span v-show="!editingService" class="headline">Nuevo</span>
            <span v-show="editingService" class="headline">Editar</span>
          </v-card-title>

          <v-card-text>
            <v-select
              :items="services_types"
              v-model="form.type"
              label="Tipo"
              data-vv-as="Tipo"
              data-vv-name="type"
              v-validate="'required'"
              :error-messages="errors.collect('type')"
            ></v-select>

            <v-text-field
              name="name"
              label="Nombre"
              v-model="form.name"
              data-vv-as="Nombre"
              data-vv-name="name"
              :error-messages="errors.collect('name')"
              v-validate="'required'"
            ></v-text-field>

            <v-text-field
              name="description"
              label="Descripción"
              v-model="form.description"
              data-vv-as="Descripción"
              data-vv-name="description"
              :error-messages="errors.collect('description')"
              v-validate="'required'"
            ></v-text-field>

            <v-checkbox
              color="primary"
              label="Tiene precio"
              v-model="form.needs_payment"
            ></v-checkbox>

            <div v-if="form.needs_payment">
              <v-checkbox
                color="primary"
                label="Único pago"
                v-model="form.one_payment"
              ></v-checkbox>

              <v-text-field
                name="price"
                label="Precio"
                v-model="form.price"
                v-money="number"
                data-vv-as="Precio"
                data-vv-name="price"
                v-validate="'required'"
                :error-messages="errors.collect('price')"
              ></v-text-field>

              <v-autocomplete
                :form="form"
                v-model="form.siesa_service_id"
                :loading="loading_courses"
                :items="siesa_courses"
                :search-input.sync="search_siesa_course"
                cache-items
                flat
                hide-no-data
                label="Servicio en siesa"
                solo-inverted
                v-validate="'required'"
                data-vv-name="siesa_service_id"
                :error-messages="errors.collect('siesa_service_id')"
                name="Curso en SIESA"
              ></v-autocomplete>

              <v-autocomplete
                :form="form"
                v-model="form.siesa_cc"
                :loading="loading_cc"
                :items="cc"
                :search-input.sync="search_cc"
                flat
                :label="$t('extracurriculares.courses.form.siesa_cc')"
                solo-inverted
                v-validate="'required'"
                data-vv-name="siesa_cc"
                :error-messages="errors.collect('siesa_cc')"
                name="Centro de costos SIESA"
              ></v-autocomplete>

              <v-autocomplete
                :form="form"
                v-model="form.siesa_seller"
                :loading="loading_seller"
                :items="sellers"
                :search-input.sync="search_seller"
                cache-items
                flat
                hide-no-data
                :label="$t('extracurriculares.courses.form.siesa_seller')"
                solo-inverted
                v-validate="'required'"
                data-vv-name="siesa_seller"
                :error-messages="errors.collect('siesa_seller')"
                name="Vendedor SIESA"
              ></v-autocomplete>

              <v-autocomplete
                :form="form"
                v-model="form.siesa_id_motivo"
                :loading="loading_motivo"
                :items="motivos"
                :search-input.sync="search_motivo"
                cache-items
                flat
                hide-no-data
                :label="$t('extracurriculares.courses.form.motivo')"
                solo-inverted
                v-validate="'required'"
                data-vv-name="siesa_id_motivo"
                :error-messages="errors.collect('siesa_id_motivo')"
                name="siesa_id_motivo"
              ></v-autocomplete>

              <v-text-field
                name="id_tipo_cli"
                label="ID tipo cli"
                v-model="form.id_tipo_cli"
                data-vv-as="ID tipo cli"
                data-vv-name="id_tipo_cli"
                v-validate="'required'"
                :error-messages="errors.collect('id_tipo_cli')"
              ></v-text-field>

              <v-text-field
                name="id_cond_pago"
                label="ID cond pago"
                v-model="form.id_cond_pago"
                data-vv-as="ID cond pago"
                data-vv-name="id_cond_pago"
                v-validate="'required'"
                :error-messages="errors.collect('id_cond_pago')"
              ></v-text-field>

              <v-text-field
                name="referencia"
                label="Referencia"
                v-model="form.referencia"
                data-vv-as="Referencia"
                data-vv-name="referencia"
                v-validate="'required'"
                :error-messages="errors.collect('referencia')"
              ></v-text-field>

              <v-text-field
                name="id_co"
                label="ID CO"
                v-model="form.id_co"
                data-vv-as="ID CO"
                data-vv-name="id_co"
                v-validate="'required'"
                :error-messages="errors.collect('id_co')"
              ></v-text-field>

              <v-text-field
                name="id_auxiliar_docto_cruce"
                label="ID aux docto cruce"
                v-model="form.id_auxiliar_docto_cruce"
                data-vv-as="ID aux docto cruce"
                data-vv-name="id_auxiliar_docto_cruce"
                v-validate="'required'"
                :error-messages="errors.collect('id_auxiliar_docto_cruce')"
              ></v-text-field>

              <v-text-field
                name="id_co_docto_cruce"
                label="ID CO docto cruce"
                v-model="form.id_co_docto_cruce"
                data-vv-as="ID CO docto cruce"
                data-vv-name="id_co_docto_cruce"
                v-validate="'required'"
                :error-messages="errors.collect('id_co_docto_cruce')"
              ></v-text-field>

              <v-text-field
                name="id_un_docto_cruce"
                label="ID UN docto cruce"
                v-model="form.id_un_docto_cruce"
                data-vv-as="ID UN docto cruce"
                data-vv-name="id_un_docto_cruce"
                v-validate="'required'"
                :error-messages="errors.collect('id_un_docto_cruce')"
              ></v-text-field>

              <v-text-field
                name="id_caja"
                label="ID caja"
                v-model="form.id_caja"
                data-vv-as="ID caja"
                data-vv-name="id_caja"
                v-validate="'required'"
                :error-messages="errors.collect('id_caja')"
              ></v-text-field>

              <v-text-field
                name="id_fe"
                label="ID FE"
                v-model="form.id_fe"
                data-vv-as="ID FE"
                data-vv-name="id_fe"
                v-validate="'required'"
                :error-messages="errors.collect('id_fe')"
              ></v-text-field>

              <v-text-field
                name="id_un"
                label="ID UN"
                v-model="form.id_un"
                data-vv-as="ID UN"
                data-vv-name="id_un"
                v-validate="'required'"
                :error-messages="errors.collect('id_un')"
              ></v-text-field>
            </div>

            <v-checkbox
              color="primary"
              label="Varios servicios"
              v-model="form.multiple_services"
            ></v-checkbox>

            <div v-if="form.multiple_services">
              <v-text-field
                name="max_services"
                label="Máximo"
                v-model="form.max_services"
                v-validate="'required'"
                type="number"
                min="1"
                :error-messages="errors.collect('max_services')"
              ></v-text-field>
            </div>

            <v-checkbox
              color="primary"
              label="Cantidad limitada"
              v-model="form.limit_services"
            ></v-checkbox>

            <div v-if="form.limit_services">
              <v-text-field
                name="available_services"
                label="Servicios disponibles"
                v-model="form.available_services"
                type="number"
                min="0"
                :error-messages="errors.collect('available_services')"
              ></v-text-field>
            </div>
            <v-checkbox
              color="primary"
              label="Maneja Idioma"
              v-model="form.handles_language"
            ></v-checkbox>

            <v-checkbox
              color="primary"
              label="Maneja Formato"
              v-model="form.handles_format"
            ></v-checkbox>

            <v-text-field
              name="admin_email"
              label="Email"
              type="email"
              v-model="form.admin_email"
              data-vv-as="Admin Email"
              data-vv-name="Admin Email"
            ></v-text-field>
            <!-- :error-messages="errors.collect('description')" -->

            <date-picker
              :form="form"
              label="Fecha inicial"
              :v-errors="errors"
              :value.sync="form.start_date"
              name="start_date"
            ></date-picker>
            <!-- <has-error :form="form" field="start_date"></has-error> -->

            <date-picker
              :form="form"
              label="Fecha final"
              :v-errors="errors"
              :value.sync="form.end_date"
              name="end_date"
            ></date-picker>

            <v-select
              :items="formats"
              v-model="form.format"
              label="Formato"
            ></v-select>

            <v-checkbox
              color="primary"
              label="Tiene grados específicos"
              v-model="form.to_spesific_grades"
            ></v-checkbox>

            <v-select
              v-if="form.to_spesific_grades"
              :items="grades"
              label="Grados"
              v-model="form.grades_select"
              data-vv-as="Grados"
              data-vv-name="grades"
              :error-messages="errors.collect('grades')"
              v-validate="'required'"
              :multiple="true"
            ></v-select>

            <v-checkbox
              color="primary"
              label="Tiene escuelas específicas"
              v-model="form.to_spesific_school"
            ></v-checkbox>

            <v-select
              v-if="form.to_spesific_school"
              :items="schools"
              label="Escuelas"
              v-model="form.school"
              data-vv-as="Escuelas"
              data-vv-name="school"
              :error-messages="errors.collect('school')"
              v-validate="'required'"
            ></v-select>

            <v-checkbox
              color="primary"
              label="Estudiantes específicos"
              v-model="form.has_students"
            ></v-checkbox>

            <div v-if="form.has_students">
              <v-autocomplete
                v-model="form.students_selected"
                :items="students"
                box
                chips
                color="primary"
                label="Seleccionar estudiantes"
                item-text="full_name"
                item-value="id"
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    class="chip--select-multi"
                    @input="remove(data.item)"
                  >
                    {{ data.item.full_name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content
                      v-text="data.item"
                    ></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title
                        v-html="data.item.full_name"
                      ></v-list-tile-title>
                      <v-list-tile-sub-title
                        v-html="'Familia: ' + data.item.family_id"
                      ></v-list-tile-sub-title>
                      <v-list-tile-sub-title
                        v-html="'Grado: ' + data.item.grade"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </div>

            <v-checkbox
              color="primary"
              label="Tiene siguiente paso"
              v-model="form.has_next_step"
            ></v-checkbox>

            <v-text-field
              v-if="form.has_next_step"
              name="next_step"
              label="Ruta siguiente paso"
              v-model="form.next_step"
              data-vv-as="Ruta siguiente paso"
              data-vv-name="next_step"
              :error-messages="errors.collect('next_step')"
              v-validate="'required'"
            ></v-text-field>

            <v-text-field
              v-if="form.has_next_step"
              name="next_step_name"
              label="Nombre acción"
              v-model="form.next_step_name"
              data-vv-as="Nombre acción"
              data-vv-name="next_step_name"
              :error-messages="errors.collect('next_step_name')"
              v-validate="'required'"
            ></v-text-field>

            <v-checkbox
              color="primary"
              label="Es publico"
              v-model="form.is_public"
            ></v-checkbox>

            <v-checkbox
              color="primary"
              label="Activo"
              v-model="form.status"
            ></v-checkbox>

            <v-text-field
              name="extra_notes"
              label="Notas extra factura"
              v-model="form.extra_notes"
              data-vv-as="Notas extra factura"
              data-vv-name="extra_notes"
              :error-messages="errors.collect('extra_notes')"
            ></v-text-field>

            <div class="editable_image" v-if="editingService && image_to_edit">
              <v-img :src="image_to_edit" width="200px"> </v-img>
              <span>
                <v-tooltip top>
                  <v-icon
                    small
                    class="mr-2"
                    @click="removeImage(form.id)"
                    slot="activator"
                  >
                    delete
                  </v-icon>
                  <span>{{ $t("extracurriculares.clothes.delete") }}</span>
                </v-tooltip>
              </span>
            </div>

            <div class="upload">
              <ul>
                <li v-for="file in files" :key="file.id">
                  <span>{{ file.name }}</span> -
                  <span>{{ file.size }}</span>
                  &nbsp;&nbsp;&nbsp;
                  <span>
                    <v-tooltip top>
                      <v-icon
                        small
                        class="mr-2"
                        @click.prevent="$refs.upload.remove(file)"
                        slot="activator"
                      >
                        delete
                      </v-icon>
                      <span>{{ $t("extracurriculares.clothes.delete") }}</span>
                    </v-tooltip>
                  </span>
                </li>
              </ul>
              <div class="example-btn">
                <file-upload
                  class="mb-2 v-btn theme--dark primary"
                  extensions="gif,jpg,jpeg,png,webp"
                  accept="image/png,image/gif,image/jpeg,image/webp"
                  :multiple="true"
                  :size="1024 * 1024 * 10"
                  v-model="files"
                  @input-filter="inputFilter"
                  @input-file="inputFile"
                  ref="upload"
                >
                  <i class="fa fa-plus"></i>
                  {{ $t("extracurriculares.clothes.form.select_files") }}
                </file-upload>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
            <v-btn
              v-if="!editingService"
              color="blue darken-1"
              flat
              @click="saveService"
              >Guardar</v-btn
            >
            <v-btn v-else color="blue darken-1" flat @click="updateService"
              >Actualizar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="services"
      :loading="loadingTable"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ getServiceType(props.item.type) }}</td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">${{ formatNumber(props.item.price) }}</td>
        <td class="text-xs-center">{{ props.item.available_services }}</td>
        <td class="text-xs-center">
          {{ props.item.format && getFormat(props.item.format) }}
        </td>
        <td class="text-xs-center">{{ props.item.grades }}</td>
        <td class="text-xs-center">{{ props.item.school }}</td>
        <td class="text-xs-center">{{ props.item.next_step }}</td>
        <td class="text-xs-center">{{ props.item.next_step_name }}</td>
        <td class="text-xs-center">
          <v-checkbox
            :key="props.item.id"
            :name="`check_${props.item.id}`"
            :input-value="props.item.is_public"
            @change="handleServicePublic(props.item.id, props.item.is_public)"
            color="primary"
            class="center"
          ></v-checkbox>
        </td>
        <td class="text-xs-center">
          <v-checkbox
            :key="props.item.id"
            :name="`check_${props.item.id}`"
            :input-value="props.item.status"
            @change="handleServiceStatus(props.item.id, props.item.status)"
            color="primary"
            class="center"
          ></v-checkbox>
        </td>
        <td>
          <v-tooltip top>
            <v-icon
              medium
              class="mr-2"
              @click="editService(props.item.id)"
              slot="activator"
            >
              edit
            </v-icon>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top>
            <v-icon
              medium
              class="mr-2"
              @click="prepareToDeleteService(props.item.id)"
              slot="activator"
            >
              delete
            </v-icon>
            <span>Eliminar</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="confirm_dialog" max-width="290">
      <v-card>
        <v-card-title class="headline"
          >¿ Está seguro que desea eliminar este servicio ?</v-card-title
        >

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="deleteService">
            Si
          </v-btn>

          <v-btn color="success" @click="confirm_dialog = false">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { VMoney } from "v-money";
import FileUpload from "vue-upload-component";
export default {
  name: "school-admin-services-view",
  directives: { money: VMoney },
  components: {
    FileUpload
  },
  data() {
    return {
      confirm_dialog: false,
      idToDelete: 0,
      dialog: false,
      editingService: false,
      headers: [
        { text: "Tipo", align: "center", value: "type" },
        { text: "Nombre", align: "center", value: "name" },
        { text: "Precio", align: "center", value: "price" },
        { text: "Disponibles", align: "center", value: "available_services" },
        { text: "Formato", align: "center", value: "format" },
        { text: "Grados", align: "center", value: "grades" },
        { text: "Escuela", align: "center", value: "school" },
        { text: "Siguiente paso", align: "center", value: "next_step" },
        { text: "Nombre acción", align: "center", value: "next_step_name" },
        { text: "Publico", align: "center", value: "is_public" },
        { text: "Activo", align: "center", value: "status" },
        { text: "Acciones", align: "center", value: "actions" }
      ],
      services: [],
      loadingTable: false,
      form: {
        type: "",
        name: "",
        needs_payment: false,
        multiple_services: false,
        limit_services: false,
        one_payment: false,
        handles_language: false,
        handles_format: false,
        admin_email: "",
        price: 0,
        max_services: 1,
        available_services: null,
        siesa_cc: "",
        siesa_co: "",
        siesa_seller: "",
        siesa_seller_id: "",
        siesa_seller_tercero_id: "",
        siesa_service_id: "",
        siesa_id_motivo: "",
        siesa_id_un: "",
        format: "",
        to_spesific_grades: false,
        grades_select: [],
        grades: "",
        to_spesific_school: false,
        school: "",
        has_next_step: false,
        next_step: "",
        next_step_name: "",
        is_public: false,
        status: true,
        id_tipo_cli: "",
        id_cond_pago: "",
        referencia: "",
        id_co: "",
        id_auxiliar_docto_cruce: "",
        id_co_docto_cruce: "",
        id_un_docto_cruce: "",
        id_caja: "",
        id_fe: "",
        id_un: "",
        description: "",
        start_date: "",
        end_date: "",
        has_students: false,
        students_selected: [],
        extra_notes: ""
      },
      files: [],
      image_to_edit: null,
      services_types: [
        { value: 1, text: "Documento" },
        { value: 2, text: "Servicio" }
      ],
      formats: [
        { value: 1, text: "PDF" },
        { value: 2, text: "PNG" }
      ],
      schools: [
        { value: "10000", text: "Early years" },
        { value: "11000", text: "Elementary School" },
        { value: "12000", text: "Middle School" },
        { value: "13000", text: "High School" },
        { value: "14000", text: "Admissions" }
      ],
      number: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false
      },
      siesa_courses: [],
      sellers: [],
      cc: [],
      motivos: [],
      search_siesa_course: null,
      search_cc: null,
      search_seller: null,
      search_motivo: null,
      loading_courses: false,
      loading_cc: false,
      loading_seller: false,
      loading_motivo: false,
      grades: [],
      serviceInEdition: {},
      students: []
    };
  },
  watch: {
    search_siesa_course(val) {
      val && val !== this.siesa_courses && this.querySiesaCourses(val);
    },
    search_cc(val) {
      val && val !== this.cc && this.queryCC(val);
    },
    search_seller(val) {
      val && val !== this.sellers && this.querySellers(val);
    },
    search_motivo(val) {
      val && val !== this.motivos && this.queryMotivos(val);
    },
    dialog(val) {
      if (!val) {
        this.form = {
          type: "",
          name: "",
          needs_payment: false,
          multiple_services: false,
          limit_services: false,
          one_payment: false,
          handles_language: false,
          handles_format: false,
          admin_email: "",
          price: 0,
          max_services: 1,
          available_services: null,
          siesa_cc: "",
          siesa_co: "",
          siesa_seller: "",
          siesa_seller_id: "",
          siesa_seller_tercero_id: "",
          siesa_service_id: "",
          siesa_id_motivo: "",
          siesa_id_un: "",
          format: "",
          to_spesific_grades: false,
          grades_select: [],
          grades: "",
          to_spesific_school: false,
          school: "",
          has_next_step: false,
          next_step: "",
          is_public: false,
          status: true,
          id_tipo_cli: "",
          id_cond_pago: "",
          referencia: "",
          id_co: "",
          id_auxiliar_docto_cruce: "",
          id_co_docto_cruce: "",
          id_un_docto_cruce: "",
          id_caja: "",
          id_fe: "",
          id_un: "",
          description: "",
          start_date: "",
          end_date: "",
          has_students: false,
          students_selected: [],
          extra_notes: ""
        };
        this.image_to_edit = null;
        this.editingService = false;
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    querySiesaCourses(v) {
      this.loading_courses = true;
      this.items = this.siesa_courses.filter(e => {
        return (
          (e.text || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
        );
      });
      this.loading_courses = false;
    },
    queryCC(v) {
      this.loading_cc = true;
      this.items = this.cc.filter(e => {
        return (
          (e.text || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
        );
      });
      this.loading_cc = false;
    },
    querySellers(v) {
      this.loading_seller = true;
      this.items = this.sellers.filter(e => {
        return (
          (e.text || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
        );
      });
      this.loading_seller = false;
    },
    queryMotivos(v) {
      this.loading_motivo = true;
      this.items = this.motivos.filter(e => {
        return (
          (e.text || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
        );
      });
      this.loading_motivo = false;
    },
    getServices() {
      axios
        .get("/api/school/services")
        .then(resp => {
          if (resp.status === 200) {
            this.services = resp.data.services;
          }
        })
        .catch(error => console.log(error));
    },
    async init() {
      this.getServices();

      const grades = await axios.get("/api/school_grades");
      grades.data.map(grade =>
        this.grades.push({ value: grade.name, text: grade.name })
      );

      axios
        .get("/api/siesa/services")
        .then(resp => {
          if (resp.status === 200) {
            resp.data.courses.map(siesa_course => {
              this.siesa_courses.push({
                value: siesa_course.id.trim(),
                text: siesa_course.nombre
              });
            });
          }
        })
        .catch(error => console.log(error));

      axios
        .get("/api/siesa/sellers")
        .then(resp => {
          if (resp.status === 200) {
            resp.data.sellers.map(seller => {
              this.sellers.push({
                value: `${seller.tercero_id.trim()}-${seller.vendedor_id.trim()}`,
                text: `${seller.vendedor_id.trim()} ${seller.razon_social.trim()}`
              });
            });
          }
        })
        .catch(error => console.log(error));

      axios
        .get("/api/siesa/cc")
        .then(resp => {
          if (resp.status === 200) {
            resp.data.cc.map(cc => {
              this.cc.push({
                value: `${cc.c_costo_id &&
                  cc.c_costo_id.trim()}-${cc.c_operativo_id &&
                  cc.c_operativo_id.trim()}-${cc.id_un && cc.id_un.trim()}`,
                text: `${cc.c_costo_id &&
                  cc.c_costo_id.trim()} ${cc.nombre.trim()}`
              });
            });
          }
        })
        .catch(error => console.log(error));

      axios
        .get("/api/siesa/motivos")
        .then(resp => {
          if (resp.status === 200) {
            resp.data.motivos.map(motivo => {
              this.motivos.push({
                value: motivo.id,
                text: `${motivo.id.trim()} ${motivo.nombre.trim()}`
              });
            });
          }
        })
        .catch(error => console.log(error));

      axios
        .get("/api/students")
        .then(resp => {
          if (resp.status === 200) {
            this.students = resp.data.students.map(student => {
              return {
                full_name: `${student.full_name} - ${student.family_id} - ${student.student_number}`,
                family_id: student.family_id,
                grade: student.grade_level,
                id: student.id,
                student_number: student.student_number
              };
            });
          }
        })
        .catch(error => console.log(error));
    },
    close() {
      this.form = {
        type: "",
        name: "",
        needs_payment: false,
        multiple_services: false,
        limit_services: false,
        one_payment: false,
        handles_language: false,
        handles_format: false,
        admin_email: "",
        price: 0,
        max_services: 1,
        available_services: null,
        siesa_cc: "",
        siesa_co: "",
        siesa_seller: "",
        siesa_seller_id: "",
        siesa_seller_tercero_id: "",
        siesa_service_id: "",
        siesa_id_motivo: "",
        siesa_id_un: "",
        format: "",
        to_spesific_grades: false,
        grades_select: [],
        grades: "",
        to_spesific_school: false,
        school: "",
        has_next_step: false,
        next_step: "",
        is_public: false,
        status: true,
        id_tipo_cli: "",
        id_cond_pago: "",
        referencia: "",
        id_co: "",
        id_auxiliar_docto_cruce: "",
        id_co_docto_cruce: "",
        id_un_docto_cruce: "",
        id_caja: "",
        id_fe: "",
        id_un: "",
        description: "",
        start_date: "",
        end_date: "",
        has_students: false,
        students_selected: [],
        extra_notes: ""
      };
      this.image_to_edit = null;
      this.dialog = false;
      this.editingService = false;
    },
    saveService() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          if (this.form.start_date > this.form.end_date) {
            this.form.errors.set({
              start_date: "La fecha inicial no puede ser mayor que la final"
            });

            return;
          }
          const siesa_cc_split = this.form.siesa_cc.split("-");
          const siesa_seller_split = this.form.siesa_seller.split("-");
          this.form.siesa_cc = siesa_cc_split[0];
          this.form.siesa_co = siesa_cc_split[1];
          this.form.siesa_id_un = siesa_cc_split[2];
          this.form.siesa_seller_tercero_id = siesa_seller_split[0];
          this.form.siesa_seller_id = siesa_seller_split[1];
          this.form.grades =
            this.form.grades_select &&
            this.form.grades_select != "" &&
            this.form.to_spesific_grades
              ? this.form.grades_select.join(", ")
              : null;
          if (!this.form.limit_services) {
            this.form.available_services = null;
          }

          axios
            .post("/api/school/service", this.form)
            .then(resp => {
              if (resp.status === 200) {
                let formData = new FormData();
                let fileData;
                this.files.forEach((file, index) => {
                  fileData = this.$refs.upload.get(file.id);
                  formData.append(`file_${index}`, fileData.file);
                });
                formData.append("service_id", resp.data.created);
                axios.post("/api/school/service/image", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

                this.files = [];
                this.getServices();
                this.close();
              }
            })
            .catch(error => console.log(error));
        }
      });
    },
    editService(id) {
      this.serviceInEdition = this.services.find(service => service.id == id);
      this.editingService = true;
      let grades_select = [];
      const siesa_seller = `${this.serviceInEdition.siesa_seller_tercero_id &&
        this.serviceInEdition.siesa_seller_tercero_id.trim()}-${this
        .serviceInEdition.siesa_seller_id &&
        this.serviceInEdition.siesa_seller_id.trim()}`;
      const siesa_cc = `${this.serviceInEdition.siesa_cc &&
        this.serviceInEdition.siesa_cc.trim()}-${this.serviceInEdition
        .siesa_co && this.serviceInEdition.siesa_co.trim()}-${this
        .serviceInEdition.siesa_id_un &&
        this.serviceInEdition.siesa_id_un.trim()}`;
      if (
        this.serviceInEdition.to_spesific_grades == "1" &&
        this.serviceInEdition.grades
      ) {
        grades_select = this.serviceInEdition.grades
          .split(",")
          .map(grade => grade.trim());
      }

      this.form = {
        id,
        type: this.serviceInEdition.type,
        name: this.serviceInEdition.name,
        needs_payment: this.serviceInEdition.needs_payment,
        multiple_services:
          this.serviceInEdition.multiple_services == 1 ? true : false,
        limit_services:
          this.serviceInEdition.limit_services == 1 ? true : false,
        one_payment: this.serviceInEdition.one_payment == 1 ? true : false,
        handles_language:
          this.serviceInEdition.handles_language == 1 ? true : false,
        handles_format:
          this.serviceInEdition.handles_format == 1 ? true : false,
        price: this.serviceInEdition.price,
        admin_email: this.serviceInEdition.admin_email,
        max_services: this.serviceInEdition.max_services,
        available_services: this.serviceInEdition.available_services,
        siesa_cc,
        siesa_co: this.serviceInEdition.siesa_co,
        siesa_seller,
        grades_select,
        siesa_seller_id: this.serviceInEdition.siesa_seller_id,
        siesa_seller_tercero_id: this.serviceInEdition.siesa_seller_tercero_id,
        siesa_service_id: this.serviceInEdition.siesa_service_id,
        siesa_id_motivo: this.serviceInEdition.siesa_id_motivo,
        siesa_id_un: this.serviceInEdition.siesa_id_un,
        format: this.serviceInEdition.format,
        to_spesific_grades: this.serviceInEdition.to_spesific_grades,
        grades: this.serviceInEdition.grades,
        to_spesific_school: this.serviceInEdition.to_spesific_school,
        school: this.serviceInEdition.school,
        has_next_step: this.serviceInEdition.has_next_step,
        next_step: this.serviceInEdition.next_step,
        is_public: this.serviceInEdition.is_public,
        status: this.serviceInEdition.status,
        id_tipo_cli: this.serviceInEdition.id_tipo_cli,
        id_cond_pago: this.serviceInEdition.id_cond_pago,
        referencia: this.serviceInEdition.referencia,
        id_co: this.serviceInEdition.id_co,
        id_auxiliar_docto_cruce: this.serviceInEdition.id_auxiliar_docto_cruce,
        id_co_docto_cruce: this.serviceInEdition.id_co_docto_cruce,
        id_un_docto_cruce: this.serviceInEdition.id_un_docto_cruce,
        id_caja: this.serviceInEdition.id_caja,
        id_fe: this.serviceInEdition.id_fe,
        id_un: this.serviceInEdition.id_un,
        description: this.serviceInEdition.description,
        start_date: this.serviceInEdition.start_date,
        end_date: this.serviceInEdition.end_date,
        has_students: this.serviceInEdition.has_students,
        students_selected: this.serviceInEdition.students.map(
          student => student.student_id
        ),
        extra_notes: this.serviceInEdition.extra_notes
      };
      (this.image_to_edit = this.serviceInEdition.image), (this.dialog = true);
    },
    updateService() {
      const siesa_cc_split = this.form.siesa_cc.split("-");
      const siesa_seller_split = this.form.siesa_seller.split("-");
      this.form.siesa_cc = siesa_cc_split[0];
      this.form.siesa_co = siesa_cc_split[1];
      this.form.siesa_id_un = siesa_cc_split[2];
      this.form.siesa_seller_tercero_id = siesa_seller_split[0];
      this.form.siesa_seller_id = siesa_seller_split[1];
      this.form.grades =
        this.form.grades_select &&
        this.form.grades_select != "" &&
        this.form.to_spesific_grades
          ? this.form.grades_select.join(", ")
          : null;
      if (!this.form.limit_services) {
        this.form.available_services = null;
      }

      axios
        .put("/api/school/service", this.form)
        .then(resp => {
          if (resp.status === 200) {
            if (this.files.length > 0) {
              let formData = new FormData();
              let fileData;
              this.files.forEach((file, index) => {
                fileData = this.$refs.upload.get(file.id);
                formData.append(`file_${index}`, fileData.file);
              });
              formData.append("service_id", this.form.id);
              axios
                .post("/api/school/service/image", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                })
                .then(result => {
                  if (result.status == 200) {
                    this.files = [];
                    this.getServices();
                    this.close();
                  }
                })
                .catch(error => console.log(error));
            } else {
              this.files = [];
              this.getServices();
              this.close();
            }
          }
        })
        .catch(error => console.log(error));
    },
    handleServiceStatus(id, status) {
      axios
        .put("/api/school/service", { id, status: !status })
        .then(resp => {
          if (resp.status === 200) {
            this.getServices();
          }
        })
        .catch(error => console.log(error));
    },
    handleServicePublic(id, is_public) {
      axios
        .put("/api/school/service", { id, is_public: !is_public })
        .then(resp => {
          if (resp.status === 200) {
            this.getServices();
          }
        })
        .catch(error => console.log(error));
    },
    prepareToDeleteService(id) {
      this.confirm_dialog = true;
      this.idToDelete = id;
    },
    deleteService() {
      const id = this.idToDelete;
      axios
        .delete(`/api/school/service/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.services = this.services.filter(service => service.id !== id);
            this.confirm_dialog = false;
          }
        })
        .catch(error => console.log(error));
    },
    getServiceType(type) {
      return this.services_types.find(
        service_type => service_type.value == type
      ).text;
    },
    getFormat(format_value) {
      return this.formats.find(format => format.value == format_value).text;
    },
    formatNumber(number) {
      if (typeof number === "undefined") {
        return 0;
      } else {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    remove(item) {
      const index = this.form.students_selected.indexOf(item.id);
      if (index >= 0) this.form.students_selected.splice(index, 1);
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log("add", newFile);
      }
      if (newFile && oldFile) {
        // update
        console.log("update", newFile);
      }
      if (!newFile && oldFile) {
        // remove
        console.log("remove", oldFile);
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    removeImage(id) {
      axios
        .put("/api/school/service", { id: id, image: "" })
        .then(resp => {
          if (resp.status === 200) {
            this.image_to_edit = null;
            this.getServices();
          }
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/school/services/create.vue